import { Language } from 'models'

const language: Language = 'ua'

// Should not be changed:
export const config = {
  language: (new URLSearchParams(window.location.search).get('lang') ||
    process.env.REACT_APP_LANG ||
    language) as Language,
  linkRu: process.env.REACT_APP_LINK_RU,
  linkUa: process.env.REACT_APP_LINK_UA,
}
